import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton } from "react-bootstrap";
import { useState, useEffect} from "react";
import {useLocation } from 'react-router-dom';
import {store} from 'Store';
import {setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import {GetTableauUserCheckboxInputData,  GetTableauUserSelectInputData, GetTableauUserRadioInputData } from 'Containers/Private/Tableau/TableauUserFields';
import {FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';
import { useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { TextButton } from "Components/Button";
import { getDocumentDownloadCall } from "Utils/utilityFunctions";
import { getResourceDownloadProps } from "Utils/fileDownloadUtil";
import { Link } from "react-router-dom";

const DownloadLink = ({groupId, linktext}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
    
    const [isLoading, setIsLoading] = useState(true);
    const [filename, setFilename] = useState(null);
    const [link, setLink] = useState(null);

    useEffect(() => {
        //loadFormData();

    }, []);

    

   

    const loadFormData = () => {
        setIsLoading(true);
        getDocumentDownloadCall(groupId).then((res) => {
            //console.log("getFormData ", res);
            //console.log(res);
            //console.log(res.headers);
            //console.log(res.headers['content-disposition']);
            // get filename from the res content-disposition
            //console.log(res.headers["content-disposition"]?.split('filename='));
            //const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            const filename = res.headers["content-disposition"]?.split('filename=')[1];
            //console.log(filename);
            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            setLink(url);

            setFilename(filename);
            a.text=res.headers["content-disposition"]?.split('filename=')[1];
            a.download = res.headers["content-disposition"]?.split('filename=')[1];
            setIsLoading(false);
            //document.body.appendChild(a); // append the element to the dom
            return {
                href:url,
                filename: filename,
            };

        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        
    };

    

    return (
        // isLoading==false 
        // ?
            // <a href={getDocURL(groupId)} download={filename} >{linktext!=null ? linktext : filename}</a>
            <Link 
                {...getResourceDownloadProps(groupId)}

                //to={getDocURL(groupId)} 
                //as={Link} 
                //target="_blank" 
                //download={docBean?.docDisplayName+"."+docBean?.docExt}
            >
                {linktext!=null ? linktext : filename}
            </Link>
        // : null    
    )
}

export default DownloadLink;
